import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.353 5.222a5.333 5.333 0 1 1 7.542 7.543 5.333 5.333 0 0 1-7.542-7.543m3.771-.229a4 4 0 1 0 0 8 4 4 0 0 0 0-8",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.262 6.855c.26.26.26.683 0 .943L8.596 9.465a.667.667 0 1 1-.943-.943l1.666-1.667c.26-.26.683-.26.943 0M12.596 4.522c.26.26.26.682 0 .943l-.667.666a.667.667 0 1 1-.943-.942l.667-.667c.26-.26.682-.26.943 0M6.124 2.327c0-.368.299-.667.667-.667h2.667a.667.667 0 0 1 0 1.333H6.79a.667.667 0 0 1-.667-.666",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })